"use strict";

module.exports = function (accumulator, order, product, component) {
  if (component.quantity > 5) {
    return component.quantity + component.num_to_add;
  }

  return component.quantity;
};